import { render, staticRenderFns } from "./RedteaReady-web.vue?vue&type=template&id=3fcdd9dc&scoped=true"
import script from "./RedteaReady-web.vue?vue&type=script&lang=js"
export * from "./RedteaReady-web.vue?vue&type=script&lang=js"
import style0 from "./RedteaReady-web.vue?vue&type=style&index=0&id=3fcdd9dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcdd9dc",
  null
  
)

export default component.exports